import { useEffect, useState } from "react";

/**
 * Значение, которое догоняет исходное с задержкой.
 *
 * Нужен полям поиска: запрос к серверу должен уходить не на каждую нажатую
 * клавишу, а когда человек на мгновение перестал печатать. Хук отдаёт значение
 * `value`, каждый раз отложенное на `delayMs` от последнего изменения; частые
 * изменения подряд схлопываются в одно, а таймер при размонтировании снимается.
 *
 * Применяется вместо самодельной пары `useState` + `useEffect` с `setTimeout`,
 * которая раньше повторялась в каждом окне выбора и поиска.
 */
export function useDebouncedValue<T>(value: T, delayMs = 250): T {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(timer);
  }, [value, delayMs]);

  return debounced;
}
